import { Switch } from '@headlessui/react'
import { NfdBrowseStateItem } from 'api/api-client'
import { classNames } from 'helpers/utilities'
import { useMemo } from 'react'

interface ForSaleToggleProps {
  state: NfdBrowseStateItem[] | null
  onChange: (value: NfdBrowseStateItem[] | null) => void
  className?: string
}

export default function ForSaleToggle({ state, onChange, className = '' }: ForSaleToggleProps) {
  const enabled = useMemo(() => {
    return state?.includes('forSale') || false
  }, [state])

  const handleChange = (checked: boolean) => {
    return checked ? onChange(['forSale']) : onChange(null)
  }

  return (
    <Switch.Group as="div" className={classNames('flex items-center', className)}>
      <Switch
        checked={enabled}
        onChange={handleChange}
        className={classNames(
          enabled ? 'bg-brand-500' : 'bg-gray-200',
          'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500'
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            enabled ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
          )}
        />
      </Switch>
      <Switch.Label as="span" className="ml-3">
        <span className="text-sm font-medium text-gray-900 whitespace-nowrap">For Sale</span>
      </Switch.Label>
    </Switch.Group>
  )
}
